module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAYAAADskT9PAAAA3klEQVR42u3UvwqCUBQG8F6quak36AUaWlqicG2NniBaChoiwohSCCoDJ4MoioJEI42iP2AiNFRo3i/0CZwuCPfA4Ry+4fCbTqIyvyBKSydHQcSqr+9K1LsMwADxBHieF07ifeG/nXB3XZce4Ho8QpZl+C8Lh1EGgtTDWdfpAT4nE7ZtgXzm0DZdcLNkkNED2IYKQgj2ax4/c4zWLhtk9AAPfQOukMdiJWKnT1GqpoKMHmDYboDLpXF7apiZPIrlJLrNGj3ARORhGwIsdYn9lodjDNDvNNkjYgAGiCfgD9KufAbrzlpAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gt.png
// module id = 831
// module chunks = 0